import _ from "lodash";
import { ajax } from "../../../../ajax/ajax";
import { CachedSearch } from "../../../../technical/cachedSearch";
import { TextInputProvider } from "../base/controlProvider";
import { SingleSelect } from "../base/singleSelect";
export class RemoteCustomSelect extends SingleSelect {
    constructor(hiddenInput, renderInline) {
        var _a;
        const valueTargetSelector = hiddenInput.data("custom-select-value-target-selector");
        super({
            container: hiddenInput.parent(),
            disabled: hiddenInput.prop("disabled"),
            name: hiddenInput.prop("name"),
            renderInline,
            hidden: hiddenInput.data("custom-select-hidden"),
            controlProvider: new TextInputProvider(),
            label: $(`label[for='${hiddenInput.prop("id")}']`),
        });
        this.freeform = hiddenInput.data("custom-select-freeform");
        this.valueTarget = valueTargetSelector
            ? hiddenInput.siblings(valueTargetSelector)
            : hiddenInput;
        this.hiddenInput = hiddenInput;
        this.displayName = hiddenInput.data("custom-select-display-name");
        this.filterResultsLocally = hiddenInput.is("[data-custom-select-local-filter]");
        this.substringMatchType =
            hiddenInput.data("custom-select-substring-match-type") || "includes";
        let include;
        const currentValue = (_a = this.valueTarget.val()) === null || _a === void 0 ? void 0 : _a.toString();
        if (this.displayName && currentValue)
            include = [{ Id: currentValue, Name: this.displayName }];
        const minLength = parseInt(hiddenInput.data("custom-select-min-length")) || undefined;
        this.cachedSearch = new CachedSearch({
            include,
            minLength,
            search: async (searchText) => {
                const response = await ajax({
                    url: this.hiddenInput.data("custom-select-url").replace(encodeURIComponent("{0}"), searchText),
                    method: "GET",
                });
                return response.success
                    ? {
                        success: true,
                        results: response.data,
                    }
                    : { success: false };
            },
            localResultMatches: (searchText, item) => item.Name.toLowerCase()[this.substringMatchType](searchText.toLowerCase()),
            identity: (item) => item.Id,
            getCacheKey: async () => this.hiddenInput.prop("id"),
        });
    }
    insert(customSelect) {
        this.hiddenInput.after(customSelect);
    }
    setSelected(chosenItem) {
        const value = chosenItem.value || "";
        this.valueTarget.val(value);
        this.hiddenInput.val(this.freeform ? chosenItem.displayName : value);
        this.displayName = chosenItem.displayName;
    }
    setValue(...values) {
        const [value] = values;
        this.hiddenInput.val(value || "");
        this.displayName = value || "";
        this.setDisplayText();
    }
    getValue() {
        return [
            { displayName: this.displayName, value: this.hiddenInput.val() },
        ];
    }
    getDisplayText() {
        return this.hiddenInput.val() ? this.displayName : "";
    }
    shouldShowOnClick() {
        return false;
    }
    hideList() {
        super.hideList();
        this.removeAllItems();
    }
    async updateDisplayedItems(searchText) {
        if (searchText === undefined || searchText === "") {
            this.removeAllItems();
            this.hideList();
            return;
        }
        const partialResult = await this.cachedSearch.get(searchText);
        this.displayItemResults(partialResult.local);
        this.toggleForResults(searchText, partialResult.local);
        if (partialResult.remote) {
            const remoteResults = await partialResult.remote;
            const filteredRemoteResults = remoteResults.filter((r) => !this.filterResultsLocally ||
                r.Name.toLowerCase()[this.substringMatchType](searchText.toLowerCase()));
            this.displayItemResults(filteredRemoteResults);
            if (!_.some(partialResult.local))
                this.toggleForResults(searchText, filteredRemoteResults);
        }
        this.autoSelect(searchText);
    }
    toggleForResults(searchText, itemResult) {
        searchText === "" || !_.some(itemResult) ? this.hideList() : this.showList();
    }
    displayItemResults(itemResults) {
        if (!_.some(itemResults))
            return;
        this.removeAllItems();
        this.addItemsInternal(false, ...itemResults.map((i) => ({
            displayName: i.Name,
            value: i.Id,
            selected: this.freeform ? undefined : i.Id === this.hiddenInput.val(),
        })));
    }
}
